import React from 'react';
import {Map, List} from 'immutable';
import {
  DATA_ATTR_COMMERCE_SKU_ID,
  COMMERCE_CART_PUBLISHED_SITE_ACTION_ATTR,
  COMMERCE_CART_PUBLISHED_SITE_ACTIONS,
} from '@packages/systems/commerce/constants';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {getCommerceDataProperty} from './ContextUtils';
import {SHARED_ANCHOR_NODE_CONSTRAINTS_DESCENDANTS} from '@packages/systems/core/constants/SharedConstraintRules';
import {TListOfElement, TRecord, TText} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const getSkuId = getCommerceDataProperty(['sku', 'id']);

const CommerceCartRemoveLink = Atom.createRender((props) => {
  const {attributes, classes, context, data, generateAttributes, renderChild} =
    props;
  const skuId = getSkuId(context);
  return (
    <a
      {...generateAttributes(attributes, classes)}
      {...{
        [COMMERCE_CART_PUBLISHED_SITE_ACTION_ATTR]:
          COMMERCE_CART_PUBLISHED_SITE_ACTIONS.REMOVE_ITEM,
        [DATA_ATTR_COMMERCE_SKU_ID]: skuId,
      }}
      aria-label="Remove item from cart"
    >
      {getChildren(data).map((child: EvaluatedNodeData) => renderChild(child))}
    </a>
  );
});

const staticBindings = Map({
  [DATA_ATTR_COMMERCE_SKU_ID]: List([
    Map({
      slug: 'sku',
      type: 'ItemRef',
    }),
    Map({
      id: 'id',
      slug: 'id',
      type: 'PlainText',
    }),
  ]),
});

const config = createIntegratedAtom({
  showEmpty: true,
  displayName: 'Remove Button',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Button')),
  },
  constraints: {
    ancestors: [{is: 'CommerceCartItem', rule: 'ExactlyOne'}],
    descendants: SHARED_ANCHOR_NODE_CONSTRAINTS_DESCENDANTS,
  },
  render: CommerceCartRemoveLink,
  staticBindings,
  fields: {children: TListOfElement, attr: TRecord({href: TText, role: TText})},
});

export default config;
